<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('dialog_title_infoReview') || '信息审核'"
      visible
      direction="rtl"
      :size="1024"
      @close="() => $refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          @close="close"
          @reload="$emit('reload')"
          :bflowTaskCode="bflowTaskCode"
          :businessType="businessType"
          :businessCode="businessCode"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    bflowTaskCode: { type: String, default: '' },
    businessType: { type: String, default: '' },
    businessCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.drawer-main {
  padding: 0 20px 20px;
}
</style>
